export default function (val?: string | number | null): string {
  return val?.toString() || 'не указано';
}
